import React, { useEffect, useState, useContext } from 'react';
import Header from '../../Header/AppHeader';
import Axiosfetch from '../../Common/Axiosfetch';
import DatePicker from 'react-datepicker';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CreateInvoice/InvoiceStyle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    //faAddressCard, 
    faSyncAlt, faReceipt, faRupeeSign
} from '@fortawesome/free-solid-svg-icons';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import baseURL from '../../Common/Config';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { ThemeContext } from '../../Common/ThemeProvider';
import FailureAlert from '../../Common/Failure';
import strings from '../../Common/Localize/QuotationLocalize';
import Select from 'react-select';
import AppFilter from '../../Common/AppFilter';
import { ValidateQuotation } from '../../Common/Validations/validation';

const AdditionalQuotationInfo = {
    Remarks: "",
    Validity: moment(new Date().setDate(new Date().getDate() + 2)).format('MM/DD/YYYY, HH:mm:ss')
};

const PackerChargesInfo = {
    SurveyID: "",
    PackingCharges: 0,
    LoadingCharges: 0,
    PickupCharges: 0,
    TransportCharges: 0,
    UnloadingCharges: 0,
    UnpackingCharges: 0,
    CarTransportCharges: 0,
    OtherCharges: 0,
    TotalAmount: 0,
    InsurancePercentage: 0,
    CreatedBy: "",
    Reason: "",
    InstantCustomerName: "",
    InstantCustomerPhone: 0,
    InstantCustomerEmail: "",
    InstantCustomerOriginCity: "",
    InstantCustomerDestCity: "",
    InstantCustomerOriginPincode: 0,
    InstantCustomerDestPincode: 0,
    InstantCustomerOriginFloor: 0,
    InstantCustomerDestFloor: 0,
    InstantCustomerIBAApproved: 0,
    InstantCustomerGSTAvailable: 0,
    InstantCustomerCFT: 0,
    InstantCustomerRemarks: ""
};

const Invoice = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    // eslint-disable-next-line
    //const [displayValueAdditionalDetails, setdisplayValueAdditionalDetails] = useState("none");
    const [Customers, setCustomers] = useState([]);
    const [CustomersInfo, setCustomersInfo] = useState([]);
    const [SelectedCustomersInfo, setSelectedCustomersInfo] = useState({});
    const [selectedCustomer, setSelectedCustomer] = useState({ value: null, label: null });
    const [SelectedQuotation, setSelectedQuotation] = useState({ value: null, label: null });
    const [QuotationDetails, setQuotationDetails] = useState(AdditionalQuotationInfo);
    const [endDate, setendDate] = useState(new Date().setDate(new Date().getDate() + 2));
    const [hideQuotation, sethideQuotation] = useState("none");
    const [QuotationData, setQuotationData] = useState([]);
    const [QuotationDropdownData, setQuotationDropdownData] = useState([]);
    const [OldTotalAmount, setOldTotalAmount] = useState(0);
    const [IsInstant, setIsInstant] = useState(false);

    const [PackerCharges, setPackerCharges] = useState(PackerChargesInfo);

    useEffect(() => {
        if (localStorage.getItem("defaultlanguage") !== null &&
            localStorage.getItem("defaultlanguage") !== "") {
            strings.setLanguage(localStorage.getItem("defaultlanguage"));
        }

        FetchCustmers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const FetchCustmers = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null) {
            Axiosfetch(baseURL + "GetActiveCustomersByPartnerID", "POST", {
                PartnerID: userData.OrganizationID,
                limit: 10,
                sorting: -1
            }, CustomerSuccess, Failure);
        }
    };

    const CustomerSuccess = (data) => {
        if (data.length > 0) {
            var customerData = [];
            setCustomersInfo(data);
            data.forEach(customer => {
                //if (customer.SurveyApproved === 1) {
                customerData.push({ label: "[#S" + customer.SurveyID + "-" + moment(customer.createdAt).local().format("DDMMYYYY") + "] " + customer.Name, value: customer._id })
                //}
            });

            setCustomers(customerData);
        }
    };

    // const addAdditionalDetails = () => {
    //     // Default validity of Quotation is 2 Days
    //     setdisplayValueAdditionalDetails("block");
    // };

    const onTextChange = (e) => {
        let value = e.target.value === "" ? 0 : parseFloat(e.target.value);
        setPackerCharges({ ...PackerCharges, [e.target.name]: value });

        if (e.target.name === "InsurancePercentage") {
            let otherchargeValue = (value === 0 ? 0 : SelectedCustomersInfo.InsuranceAmount * (value / 100));
            setPackerCharges({ ...PackerCharges, "OtherCharges": otherchargeValue, "InsurancePercentage": value });
        }
    };

    const onInstantTextChange = (e) => {
        if (e.target.name === "InstantCustomerName" || e.target.name === "InstantCustomerRemarks") {
            setPackerCharges({ ...PackerCharges, [e.target.name]: e.target.value });
        }
        else {
            let value = e.target.value === "" ? 0 : e.target.value;
            setPackerCharges({ ...PackerCharges, [e.target.name]: value });
        }

    };

    const onInstantIBAChecked = (e) => {
        let value = e.target.checked ? 1 : 0;
        setPackerCharges({ ...PackerCharges, [e.target.name]: value });
    };

    const onReasonChange = (e) => {
        let quote = PackerCharges;
        quote.Reason = e.target.value;
        setPackerCharges(quote);
    };

    const onAdditionalQuotationDetailsChange = (e) => {
        setQuotationDetails({ ...QuotationDetails, [e.target.name]: e.target.value });
    };

    const onValidityChange = (date) => {
        setendDate(date);
        setQuotationDetails({ ...QuotationDetails, Validity: moment(date) });
    };

    const hideQuotationModal = () => {
        if (hideQuotation === "none") {
            GetQuotations();
        }
        sethideQuotation(hideQuotation === "none" ? "block" : "none");
    };

    const ImportQuotationDetails = () => {
        let quotation = SelectedQuotation.value !== null ? SelectedQuotation.value : "";
        let SelectedQuotationDetails = QuotationData.filter(q => { return q._id === quotation });
        if (SelectedQuotationDetails.length > 0) {

            if (SelectedQuotationDetails[0].Customer.length > 0) {
                setSelectedCustomer({ label: "[#S" + SelectedQuotationDetails[0].Customer[0].SurveyID + "-" + moment(SelectedQuotationDetails[0].Customer[0].createdAt).local().format("DDMMYYYY") + "] " + SelectedQuotationDetails[0].Customer[0].CompanyName, value: SelectedQuotationDetails[0].Customer[0]._id })
                setSelectedCustomersInfo(SelectedQuotationDetails[0].Customer[0]);
            }

            const packerInfo = {
                SurveyID: (SelectedQuotationDetails[0].Customer.length > 0 ? SelectedQuotationDetails[0].Customer[0].SurveyID : null),
                PackingCharges: SelectedQuotationDetails[0].PackingCharges,
                LoadingCharges: SelectedQuotationDetails[0].LoadingCharges,
                PickupCharges: SelectedQuotationDetails[0].PickupCharges,
                TransportCharges: SelectedQuotationDetails[0].TransportCharges,
                UnpackingCharges: SelectedQuotationDetails[0].UnpackingCharges,
                UnloadingCharges: SelectedQuotationDetails[0].UnloadingCharges,
                CarTransportCharges: SelectedQuotationDetails[0].CarTransportCharges,
                OtherCharges: SelectedQuotationDetails[0].OtherCharges,
                TotalAmount: SelectedQuotationDetails[0].TotalAmount,
                CreatedBy: SelectedQuotationDetails[0].CreatedBy,
            };

            const additionalDetails = {
                Remarks: SelectedQuotationDetails[0].Remarks,
                Validity: moment(SelectedQuotationDetails[0].Validity)
            }

            if (SelectedQuotationDetails[0].IsInstant === 1) {
                setIsInstant(true);
                packerInfo.InstantCustomerName = SelectedQuotationDetails[0].InstantCustomerName;
                packerInfo.InstantCustomerPhone = SelectedQuotationDetails[0].InstantCustomerPhone;
                packerInfo.InstantCustomerEmail = SelectedQuotationDetails[0].InstantCustomerEmail;
                packerInfo.InstantCustomerOriginCity = SelectedQuotationDetails[0].InstantCustomerOriginCity;
                packerInfo.InstantCustomerDestCity = SelectedQuotationDetails[0].InstantCustomerDestCity;
                packerInfo.InstantCustomerOriginPincode = SelectedQuotationDetails[0].InstantCustomerOriginPincode;
                packerInfo.InstantCustomerDestPincode = SelectedQuotationDetails[0].InstantCustomerDestPincode;
                packerInfo.InstantCustomerOriginFloor = SelectedQuotationDetails[0].InstantCustomerOriginFloor;
                packerInfo.InstantCustomerDestFloor = SelectedQuotationDetails[0].InstantCustomerDestFloor;
                packerInfo.InstantCustomerIBAApproved = SelectedQuotationDetails[0].InstantCustomerIBAApproved;
                packerInfo.InstantCustomerGSTAvailable = SelectedQuotationDetails[0].InstantCustomerGSTAvailable;
                packerInfo.InstantCustomerCFT = SelectedQuotationDetails[0].InstantCustomerCFT;
                packerInfo.InstantCustomerRemarks = SelectedQuotationDetails[0].InstantCustomerRemarks;
            }

            setPackerCharges(packerInfo);
            setOldTotalAmount(SelectedQuotationDetails[0].TotalAmount);
            setQuotationDetails(additionalDetails);
        }

        if (quotation !== "") {
            sethideQuotation(hideQuotation === "none" ? "block" : "none");
        }
        else {
            Alert.error("Please select a valid Quotation.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    // const hideAdditionalDetails = () => {
    //     setdisplayValueAdditionalDetails("none");
    // };

    const GetQuotations = () => {
        Axiosfetch(baseURL + "GetQuotationsByStatus", "POST", { Status: 1 }, quotationDataSuccess, Failure);

    };

    const quotationDataSuccess = (data) => {
        if (data.length > 0) {
            setQuotationData(data);
            var quotation = [];
            data.forEach(Quotation => {
                let QuotationName = "#" + Quotation.QuoteID + "_" + moment(Quotation.createdAt).local().format("DDMMYYYY")
                quotation.push({ value: Quotation._id, label: QuotationName });
            });
            setQuotationDropdownData(quotation);
        }
        else {
            setQuotationData([]);
            setQuotationDropdownData({ value: null, label: null });
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const GenerateQuotation = () => {
        if (IsQuotationDetailsValid()) {
            let quotation = SelectedQuotation.value !== null ? SelectedQuotation.value : "";
            if (quotation !== "") {
                let quotationdetails = QuotationData.filter(q => q._id === quotation);
                confirmAlert({
                    customUI: ({ onClose }) => {
                        return (
                            <div className={`custom-ui${CurrentTheme}`}>
                                {quotationdetails.length > 0 && <p><b>Selected Quotation : </b>{"#" + quotationdetails[0].QuoteID + "_" + moment(quotationdetails[0].createdAt).local().format("DDMMYYYY")}</p>}
                                <h3>Generate Quotation Confirmation</h3>
                                <div style={{ paddingTop: "10px" }}>
                                    <div className="text-field">
                                        <textarea placeholder="" name="Reason" value={PackerCharges.Reason}
                                            onChange={onReasonChange}></textarea>
                                        <span>Update Reason *</span>
                                    </div>
                                </div>
                                <p>Choose the Valid option...</p>
                                <button type="button" style={{ fontSize: "1.4rem", marginRight: "10px" }} title="Updated Selected Quotation" className="btn btn-Save" onClick={() => { SaveQuotation("edit"); if (PackerCharges.Reason !== undefined && PackerCharges.Reason !== "") { onClose(); } }}>Update</button>
                                <button type="button" className="btn btn-default" onClick={onClose}>Close</button>
                            </div>
                        );
                    }
                });
            }
            else {
                SaveQuotation("add");
            }
        }
    };

    const IsQuotationDetailsValid = () => {
        let ErrorMsg = "";
        //var currentDate = new Date();
        if (selectedCustomer.value === "") {
            ErrorMsg = strings.PleaseSelectCustomer;
        }
        if (ErrorMsg !== "") {
            Alert.error(ErrorMsg, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const onChangeCustomer = (customer) => {
        setSelectedCustomer({ value: (customer ? customer.value : null), label: (customer ? customer.label : null) });
        if (customer) {
            let customerInfo = CustomersInfo.filter(c => c._id === customer.value);
            if (customerInfo.length > 0 && customerInfo[0].IsGSTAvailable && customerInfo[0].IsInsured) {
                setSelectedCustomersInfo(customerInfo[0]);
                let packing = PackerCharges;
                packing.InsurancePercentage = 3;
                packing.OtherCharges = customerInfo[0].InsuranceAmount * (packing.InsurancePercentage > 0 ? (packing.InsurancePercentage / 100) : 1);
                setPackerCharges(packing);
            }
        }
        else {
            let packing = PackerCharges;
            packing.InsurancePercentage = 0;
            packing.OtherCharges = 0;
            setPackerCharges(packing);
            setSelectedCustomersInfo({});
        }
    };

    const onChangeQuotation = (quotation) => {
        setSelectedQuotation({ value: (quotation ? quotation.value : null), label: (quotation ? quotation.label : null) });
    };

    // const SaveAdditionalQuotationDetails = () => {
    //     hideAdditionalDetails();
    // };

    const SaveQuotation = (type) => {
        var Quote = PackerCharges;
        Quote.CustomerID = selectedCustomer.value;
        Quote.TotalAmount = document.getElementById("totalAmount").value !== "" ? parseFloat(document.getElementById("totalAmount").value) : 0;
        Quote.Remarks = QuotationDetails.Remarks;
        Quote.Validity = QuotationDetails.Validity;
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null) {
            Quote.CreatedBy = userData._id;
            Quote.OrgID = userData.OrganizationID;
            Quote.IsInstant = IsInstant ? 1 : 0;

            if (ValidateQuotation(Quote, IsInstant)) {
                if (type === "add") {
                    Axiosfetch(baseURL + "CreateQuotation", "POST", Quote, quotationAddSuccess, Failure);
                }
                else {
                    if (PackerCharges.Reason !== undefined && PackerCharges.Reason !== "") {
                        let quotation = SelectedQuotation.value !== "" ? SelectedQuotation.value : "";
                        let SelectedQuotationDetails = QuotationData.filter(q => { return q._id === quotation });
                        if (SelectedQuotationDetails.length > 0) {
                            Quote.ID = SelectedQuotationDetails[0]._id;
                            Quote.PreviousTotal = OldTotalAmount;
                            Axiosfetch(baseURL + "EditQuotation", "POST", Quote, quotationAddSuccess, Failure);
                        }
                    }
                    else {
                        Alert.error("Please enter Reason for update", {
                            position: 'bottom-right',
                            effect: 'slide',
                            html: false
                        });
                    }
                }
            }
        }
        else {
            Alert.error("Error getting User Data. Please login and try again", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const quotationAddSuccess = (data) => {
        if (data !== "") {
            Alert.success("Quotation Created Successfully", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });


            let packing = PackerChargesInfo;
            packing.InsurancePercentage = 0;
            packing.OtherCharges = 0;

            setPackerCharges(PackerChargesInfo);
            setQuotationDetails(AdditionalQuotationInfo);
            setSelectedCustomer({ value: null, label: null });
            setSelectedQuotation({ value: null, label: null });
            setSelectedCustomersInfo({});
        }
        else {
            Alert.error("Error Creating Quotation", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnFilterData = (filterData) => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null) {
            Axiosfetch(baseURL + "GetActiveCustomersByPartnerID", "POST", { PartnerID: userData.OrganizationID, limit: filterData.item, sorting: filterData.checkedItem }, CustomerSuccess, Failure);
        }
    };

    const OnInstantCheck = (e) => {
        setIsInstant(e.target.checked);

        setSelectedCustomer({ value: null, label: null });
    }

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show" >
                <div id="page" className="quotemainHeight">
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-12">
                            <div className="align-center" style={{ fontWeight: "500", fontSize: "20px" }}>{strings.Quotation} System</div>
                        </div>

                    </div>
                    <div className="row title customerStyle" style={{
                        scrollbarColor: "#005582 transparent"
                    }}>
                        <div className="col-md-5 col-sm-5 col-12" style={{ borderRight: "1px solid #ccc" }}>
                            <div className="align-right">
                                <input style={{ marginRight: "10px" }} checked={IsInstant} onChange={OnInstantCheck} type="checkbox"></input><span>Instant Quote</span>
                            </div>
                            {!IsInstant && (<div style={{ margin: "auto 0" }}>
                                <div style={{ fontWeight: "600" }}>Customer Survey<span className="mandatoryStar">*</span></div>
                            </div>)}
                            {!IsInstant && (<div style={{ display: "flex" }}>
                                <div className="dropdownMobile" style={{ width: "70%" }}>
                                    <Select value={selectedCustomer.value !== null ? selectedCustomer : ''} isClearable={true} isSearchable={true} placeholder="Select Survey"
                                        options={Customers}
                                        onChange={onChangeCustomer}></Select>
                                </div>
                                <div style={{ marginLeft: "10px", padding: "5px 15px 0 0", cursor: "pointer" }}>
                                    <AppFilter onFilterSave={OnFilterData}></AppFilter>
                                </div>
                                <div onClick={hideQuotationModal} className={`align-right cursor ${CurrentTheme}Color`} style={{ fontSize: "1.4rem" }}>
                                    <FontAwesomeIcon data-tip={strings.ImportQuote} icon={faReceipt} />
                                </div>
                                {/* {selectedCustomer.value !== null && parseInt(selectedCustomer.value) > 0 && (<div className={`col-md-1 col-sm-1 align-right font-size-15rem cursor ${CurrentTheme === "default" ? "addressCardStyle" : "addressCardStyleDark"}`}>
                                    <div onClick={addAdditionalDetails}>
                                        <span className={`addressCardStyle ${CurrentTheme}Color`}><FontAwesomeIcon icon={faAddressCard} /></span>
                                    </div>
                                </div>)} */}
                            </div>)}
                            {IsInstant && (<div style={{
                                height: "55vh",
                                scrollbarColor: "#005582 transparent", overflow: "auto"
                            }}>
                                <div className="text-field">
                                    <input style={{ padding: "8px" }} placeholder="" name="InstantCustomerName" value={PackerCharges.InstantCustomerName}
                                        onChange={(e) => onInstantTextChange(e)}
                                        type="text"></input>
                                    <span>Customer Name<span className="mandatoryStar">*</span></span>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div className="text-field" style={{ flex: "2" }}>
                                        <input style={{ padding: "8px" }} placeholder="" name="InstantCustomerPhone" value={(PackerCharges.InstantCustomerPhone === 0 || isNaN(PackerCharges.InstantCustomerPhone) ? "" : PackerCharges.InstantCustomerPhone)}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Customer Phone<span className="mandatoryStar">*</span></span>
                                    </div>
                                    <div style={{ margin: "auto", flex: "1" }}>
                                        <div className="switch">
                                            <input name="InstantCustomerIBAApproved"
                                                checked={(PackerCharges.InstantCustomerIBAApproved !== undefined &&
                                                    PackerCharges.InstantCustomerIBAApproved === 1)}
                                                onChange={onInstantIBAChecked} id="switch3"
                                                type="checkbox" className="switch-input" />
                                            <label htmlFor="switch3" className="switch-label">Switch</label>
                                        </div>
                                        <span style={{ paddingLeft: "10px" }}>IBA Approval ?</span>
                                    </div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div className="text-field" style={{ flex: "2" }}>
                                        <input style={{ padding: "8px" }} placeholder="" name="InstantCustomerEmail" value={PackerCharges.InstantCustomerEmail}
                                            onChange={(e) => onInstantTextChange(e)}
                                            type="text"></input>
                                        <span>Customer Email<span className="mandatoryStar">*</span></span>
                                    </div>
                                    <div style={{ margin: "auto", flex: "1" }}>
                                        <div className="switch">
                                            <input name="InstantCustomerGSTAvailable"
                                                checked={(PackerCharges.InstantCustomerGSTAvailable !== undefined &&
                                                    PackerCharges.InstantCustomerGSTAvailable === 1)}
                                                onChange={onInstantIBAChecked} id="switch1"
                                                type="checkbox" className="switch-input" />
                                            <label htmlFor="switch1" className="switch-label">Switch</label>
                                        </div>
                                        <span style={{ paddingLeft: "10px" }}>GST ?</span>
                                    </div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div className="text-field" style={{ width: "50%" }}>
                                        <input style={{ padding: "8px" }} placeholder="" name="InstantCustomerOriginCity" value={PackerCharges.InstantCustomerOriginCity}
                                            onChange={(e) => onInstantTextChange(e)}
                                            type="text"></input>
                                        <span>Origin City<span className="mandatoryStar">*</span></span>
                                    </div>
                                    <div className="text-field" style={{ width: "50%" }}>
                                        <input style={{ padding: "8px" }} placeholder="" name="InstantCustomerDestCity" value={PackerCharges.InstantCustomerDestCity}
                                            onChange={(e) => onInstantTextChange(e)}
                                            type="text"></input>
                                        <span>Destination City<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div className="text-field" style={{ width: "50%" }}>
                                        <input style={{ padding: "8px" }} placeholder="" name="InstantCustomerOriginPincode" value={(PackerCharges.InstantCustomerOriginPincode === 0 || isNaN(PackerCharges.InstantCustomerOriginPincode) ? "" : PackerCharges.InstantCustomerOriginPincode)}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Origin Pincode<span className="mandatoryStar">*</span></span>
                                    </div>
                                    <div className="text-field" style={{ width: "50%" }}>
                                        <input style={{ padding: "8px" }} placeholder="" name="InstantCustomerDestPincode" value={(PackerCharges.InstantCustomerDestPincode === 0 || isNaN(PackerCharges.InstantCustomerDestPincode) ? "" : PackerCharges.InstantCustomerDestPincode)}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Destination Pincode<span className="mandatoryStar">*</span></span>
                                    </div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div className="text-field" style={{ width: "50%" }}>
                                        <input style={{ padding: "8px" }} placeholder="" name="InstantCustomerOriginFloor" value={(PackerCharges.InstantCustomerOriginFloor === 0 || isNaN(PackerCharges.InstantCustomerOriginFloor) ? "" : PackerCharges.InstantCustomerOriginFloor)}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Origin Floor</span>
                                    </div>
                                    <div className="text-field" style={{ width: "50%" }}>
                                        <input style={{ padding: "8px" }} placeholder="" name="InstantCustomerDestFloor" value={(PackerCharges.InstantCustomerDestFloor === 0 || isNaN(PackerCharges.InstantCustomerDestFloor) ? "" : PackerCharges.InstantCustomerDestFloor)}
                                            onChange={(e) => onTextChange(e)}
                                            type="text"></input>
                                        <span>Destination Floor</span>
                                    </div>
                                </div>
                                <div className="text-field">
                                    <input style={{ padding: "8px" }} placeholder="" name="InstantCustomerCFT" value={(PackerCharges.InstantCustomerCFT === 0 || isNaN(PackerCharges.InstantCustomerCFT) ? "" : PackerCharges.InstantCustomerCFT)}
                                        onChange={(e) => onTextChange(e)}
                                        type="text"></input>
                                    <span>Total CFT</span>
                                </div>
                                <div className="text-field">
                                    <textarea style={{ padding: "8px" }} placeholder="" name="InstantCustomerRemarks" value={PackerCharges.InstantCustomerRemarks}
                                        onChange={(e) => onInstantTextChange(e)}
                                        rows="2" type="text"></textarea>
                                    <span>Remarks</span>
                                </div>
                            </div>)}

                            {(!IsInstant && selectedCustomer.value && parseInt(selectedCustomer.value) > 0) && (<div style={{ marginTop: "10px" }}>
                                <table className="table">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <h5>{strings.Remarks}</h5>
                                            </td>
                                            <td>
                                                <textarea style={{ resize: "none" }} onChange={(e) => onAdditionalQuotationDetailsChange(e)} rows="2"
                                                    className="form-control" name="Remarks" value={QuotationDetails.Remarks}></textarea>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <h5>{strings.Validity}<span className="mandatoryStar">*</span></h5>
                                            </td>
                                            <td>
                                                <DatePicker selected={endDate}
                                                    onChange={onValidityChange}
                                                    showTimeSelect className="form-control"
                                                    timeIntervals={15}
                                                    timeCaption="time"
                                                    dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>)}
                        </div>

                        <div className="col-md-7 col-sm-7 col-12 tableQuoteStyle quotetableHeight" style={{
                            scrollbarColor: "#005582 transparent"
                        }}>
                            <table className="table table-striped" style={{ border: "1px solid #ccc" }}>
                                <thead className="StickyHeader">
                                    <tr>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`} style={{ width: "60px" }}>SI No.</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Particular</th>
                                        <th className={`align-center InvoicetitleStyle ${CurrentTheme}`}>Amount</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: "14px" }}>
                                    <tr className="align-center">
                                        <td>1</td>
                                        <td>Wrapping & Packaging Charges</td>
                                        <td><input type="text" name="PackingCharges"
                                            value={!isNaN(PackerCharges.PackingCharges) ? PackerCharges.PackingCharges : ""} onChange={e => onTextChange(e)} style={{ width: "30%", margin: "auto", height: "28px", textAlign: "center" }} className="form-control"></input></td>
                                    </tr>
                                    <tr className="align-center">
                                        <td>2</td>
                                        <td>Loading & Stuffing Charges</td>
                                        <td><input type="text" name="LoadingCharges"
                                            value={!isNaN(PackerCharges.LoadingCharges) ? PackerCharges.LoadingCharges : ""}
                                            onChange={e => onTextChange(e)} style={{ width: "30%", margin: "auto", height: "28px", textAlign: "center" }} className="form-control"></input></td>
                                    </tr>
                                    <tr className="align-center">
                                        <td>3</td>
                                        <td>Pickup & Delivery Charges</td>
                                        <td><input type="text" name="PickupCharges"
                                            value={!isNaN(PackerCharges.PickupCharges) ? PackerCharges.PickupCharges : ""}
                                            onChange={e => onTextChange(e)} style={{ width: "30%", margin: "auto", height: "28px", textAlign: "center" }} className="form-control"></input></td>
                                    </tr>
                                    <tr className="align-center">
                                        <td>4</td>
                                        <td>Moving & Transportation Charges</td>
                                        <td><input type="text" name="TransportCharges"
                                            value={!isNaN(PackerCharges.TransportCharges) ? PackerCharges.TransportCharges : ""}
                                            onChange={e => onTextChange(e)} style={{ width: "30%", margin: "auto", height: "28px", textAlign: "center" }} className="form-control"></input></td>
                                    </tr>
                                    <tr className="align-center">
                                        <td>5</td>
                                        <td>Unloading Charges</td>
                                        <td><input type="text" name="UnloadingCharges"
                                            value={!isNaN(PackerCharges.UnloadingCharges) ? PackerCharges.UnloadingCharges : ""}
                                            onChange={e => onTextChange(e)} style={{ width: "30%", margin: "auto", height: "28px", textAlign: "center" }} className="form-control"></input></td>
                                    </tr>
                                    <tr className="align-center">
                                        <td>6</td>
                                        <td>Unpacking & Settling Charges</td>
                                        <td><input type="text" name="UnpackingCharges"
                                            value={!isNaN(PackerCharges.UnpackingCharges) ? PackerCharges.UnpackingCharges : ""}
                                            onChange={e => onTextChange(e)} style={{ width: "30%", margin: "auto", height: "28px", textAlign: "center" }} className="form-control"></input></td>
                                    </tr>
                                    <tr className="align-center">
                                        <td>7</td>
                                        <td>Car Transportation Charges</td>
                                        <td><input type="text" name="CarTransportCharges"
                                            value={!isNaN(PackerCharges.CarTransportCharges) ? PackerCharges.CarTransportCharges : ""}
                                            onChange={e => onTextChange(e)} style={{ width: "30%", margin: "auto", height: "28px", textAlign: "center" }} className="form-control"></input></td>
                                    </tr>
                                    <tr className="align-center">
                                        <td>8</td>
                                        <td>Other Charges</td>
                                        <td>
                                            <div style={{ display: "flex", justifyContent: 'center' }}>
                                                <input type="text" name="OtherCharges"
                                                    value={!isNaN(PackerCharges.OtherCharges) ? PackerCharges.OtherCharges : ""}
                                                    onChange={e => onTextChange(e)} style={{ width: "20%", height: "28px", textAlign: "center" }} className="form-control"></input>
                                                <input type="number" disabled={(SelectedCustomersInfo.IsInsured !== undefined ? SelectedCustomersInfo.IsInsured === 0 : true)} name="InsurancePercentage"
                                                    value={PackerCharges.InsurancePercentage > 0 ? PackerCharges.InsurancePercentage : 0}
                                                    onChange={e => onTextChange(e)} style={{ width: "10%", height: "28px", textAlign: "center" }} className="form-control"></input>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8 col-sm-8 col-12 align-right trackbtn">
                            <button className={`btn btn-General ${CurrentTheme}Focus`} style={{ width: "150px" }} onClick={GenerateQuotation}> <FontAwesomeIcon icon={faSyncAlt} style={{ marginRight: "5px" }} />
                                {strings.Generate}
                            </button>
                        </div>
                        <div className="col-md-4 col-sm-4 col-12">
                            <div className="input-group">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" style={{ fontWeight: "600", minWidth: "150px" }}>{strings.Total}</span>
                                </div>
                                <input type="text" readOnly={true} className="form-control align-center" style={{ minWidth: "60px" }}
                                    id="totalAmount" value={PackerCharges.PackingCharges + PackerCharges.LoadingCharges + PackerCharges.PickupCharges +
                                        PackerCharges.TransportCharges + PackerCharges.UnpackingCharges + PackerCharges.UnloadingCharges +
                                        PackerCharges.CarTransportCharges + PackerCharges.OtherCharges}></input><div>
                                    <span className="font-size15rem padding-topLeft"><FontAwesomeIcon className="font-size2rem padding-topLeft" icon={faRupeeSign}></FontAwesomeIcon></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="SelectPrevQuotation" className="modal" style={{ display: hideQuotation }}>
                    <div className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>{strings.SelectQuote}</span>
                            <span className="close" onClick={hideQuotationModal}>&times;</span>
                        </div>

                        <table className="table tableTDWidthStyle">
                            <tbody>
                                <tr className="align-center">
                                    <td style={{ width: "30%" }}>
                                        <h5>{strings.Quotation}<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td >
                                        <div style={{ width: "90%" }}>
                                            <Select isClearable={true} value={SelectedQuotation.value === null ? '' : SelectedQuotation} isSearchable={true} placeholder="Select Quotation"
                                                options={QuotationDropdownData}
                                                onChange={onChangeQuotation}></Select>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right" }} colSpan="2">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={ImportQuotationDetails}>{strings.Select}</button>
                                                <button type="button" className="btn btn-default" onClick={hideQuotationModal}>{strings.Close}</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* <div id="myModal3" className="modal" style={{ display: displayValueAdditionalDetails }}>
                    <div className="modal-content">
                        <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                            <span style={{ marginLeft: "5px", padding: "5px" }}>{strings.AdditionalQuotationDetails}</span>
                            <span className="close" onClick={hideAdditionalDetails}>&times;</span>
                        </div>
                        <table className="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <h5>{strings.Remarks}</h5>
                                    </td>
                                    <td>
                                        <textarea onChange={(e) => onAdditionalQuotationDetailsChange(e)} rows="2"
                                            className="form-control" name="Remarks" value={QuotationDetails.Remarks}></textarea>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <h5>{strings.Validity}<span className="mandatoryStar">*</span></h5>
                                    </td>
                                    <td>
                                        <DatePicker selected={endDate}
                                            onChange={onValidityChange}
                                            showTimeSelect className="form-control"
                                            timeIntervals={15}
                                            timeCaption="time"
                                            dateFormat="MMMM d, yyyy h:mm aa"></DatePicker>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: "right" }} colSpan="2">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={SaveAdditionalQuotationDetails}>{strings.Save}</button>
                                                <button type="button" className="btn btn-default" onClick={hideAdditionalDetails}>{strings.Close}</button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> */}
            </div>
        </div >
    );
};

export default Invoice;